import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import DataTable from 'react-data-table-component';
import FilterComponent from "./FilterComponent";
import Spinner from "../components/layout/Spinner";
import { PERMISSIONS } from '../Permission/Permission';
import { getAllChannelList, dealerList } from "../store/dealer/actions";
import { updateDealerCredentials, resetAlert, pageNumber } from "../store/addDealerCredentials/actions";
import BulkUploadTMobilePassword from "../components/BulkUploadTMobilePassword"
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

function AddDealerCredentials(props) {
  const dispatch = useDispatch();
  const [RoleID, setRoleID] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [dataSearch, setDataSearch] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [LoginId, setLoginID] = useState('');
  const [popUp, setpopUp] = useState(false);
  const [popUpDeleteContent, setPopUpDeleteContent] = useState('');
  const [allowExport, setAllowExport] = useState(false);
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const [searchDealer, setSearchDealer] = useState({
    companyID: '',
    channelId: 0,
    status: 0,
  });
  useEffect(() => {
    const loginId = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).ID
      : null;
    const companyId = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).CompanyID
      : null;
    const roleId = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')).RoleID : null;
    const dealerId = localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")).DealerId : null;
    setRoleID(roleId);
    setLoginID(loginId);
    setSearchDealer((prevState) => ({
      ...prevState,
      companyID: companyId,
    }));
    props.getAllChannelList(dealerId);
  }, []);

  useEffect(() => {
    if (props.updatemessage || props.bulkUpdatemessage) {
      dispatch(dealerList(searchDealer.companyID, searchDealer.channelId, searchDealer.status));
      setAllowExport(true);
    }
  }, [props.updatemessage, props.updateError, props.bulkUpdatemessage]);


  useEffect(() => {
    dispatch(resetAlert());
  }, [])

  useEffect(() => {
    if (props.dealerData && props.dealerData.length > 0) {
      const result = props.dealerData.map((data) => ({
        id: data.ID,
        employeeID: data.EmployeeID ?? '',
        newUsername: data.NewUsername ?? '',
        newPassword: data.NewPassword ?? ''
      }));
      setEditedData(result);
    } else {
      setEditedData([]);
    }
  }, [props.dealerData]);



  var filterArray = [];
  for (const [key, value] of Object.entries(PERMISSIONS)) {
    if (key == RoleID) {
      filterArray.push(value);
    }
  }

  const columns = [
    {
      name: "#",
      width: "30px",
      selector: row => row.serial,
    },
    {
      name: "DEALER NAME",
      selector: row => row.dealerName,
    },
    {
      name: "ACode",
      selector: row => row.ACode,
    },
    {
      name: "CHANNEL",
      selector: row => row.ChannelName,
    },
    {
      name: "OLD TMO USERNAME",
      selector: row => row.oldTmobileUsername,
    },
    filterArray && filterArray.length > 0 && filterArray[0].includes("suspend_dealer") && {
      name: "SUSPENDED",
      selector: row => row.suspense,
    },
    {
      name: "EMPLOYEE ID",
      selector: row => row.employeeID,
    },
    {
      name: "NEW USERNAME",
      selector: row => row.newUsername,
    },
    {
      name: "NEW PASSWORD",
      selector: row => row.newPassword,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: '50px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '0px',
        fontWeight: 'bold',
        fontSize: '14px'
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '0px',
      },
    },
  };

  const handleInputChange = (id, field, value) => {
    let tempUpdatedData = editedData.map((item) => {
      if (item.id == id) {
        return {
          ...item,
          [field]: value
        }
      } else {
        return item;
      }
    });
    setEditedData(tempUpdatedData);
    // setEditedData(prev => ({
    //   ...prev,
    //   [id]: { ...prev[id], [field]: value }
    // }));
  };


  const handleUpdate = () => {
    setpopUp(true);
    setPopUpDeleteContent('Are you sure you want to update these details ?')
  }

  const handleconfirm = () => {
    const updatedData = Object.entries(editedData).length > 0 ? Object.entries(editedData).map(([id, values]) => ({
      id: values.id,
      employeeID: values.employeeID,
      newUsername: values.newUsername,
      newPassword: values.newPassword,
      modifiedBy: LoginId
    }))
      : [];
    // console.log("updatedData", updatedData);
    dispatch(updateDealerCredentials(updatedData));
    setpopUp(false);
  }

  const filteredItems = props.dealerData && props.dealerData.filter(
    item => JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !== -1

  );
  const filterData = filteredItems && filteredItems.map((data, key) => {

    const tempEmpIdArr = editedData.length > 0 && editedData.filter((item) => item.id == data.ID);
    const tempEmpId = tempEmpIdArr.length > 0 ? tempEmpIdArr[0].employeeID : '';

    const tempUsernameArr = editedData.length > 0 && editedData.filter((item) => item.id == data.ID);
    const tempUsername = tempUsernameArr.length > 0 ? tempUsernameArr[0].newUsername : '';

    const tempNewPasswordArr = editedData.length > 0 && editedData.filter((item) => item.id == data.ID);
    const tempNewPassword = tempNewPasswordArr.length > 0 ? tempNewPasswordArr[0].newPassword : '';

    return {
      serial: (<p>{key + 1}</p>),
      dealerName: (<p style={{ "whiteSpace": "break-spaces" }}>{data.DealerName}</p>),
      ChannelName: (<p>{data.ChannelName}</p>),
      ACode: (<p>{(data.ACode == null || data.ACode == '') ? '' : data.ACode}</p>),
      oldTmobileUsername: (<p>{data.TMobileUsername}</p>),
      suspense: (<p style={{ 'fontWeight': 'bold' }} className={`${data.SuspenseFlag === 1 ? 'text-danger' : 'text-success'}`}>{data.SuspenseFlag === 1 ? 'Yes' : 'No'}</p>),
      employeeID: (
        <input
          type="text"
          value={tempEmpId}
          onChange={(e) => handleInputChange(data.ID, 'employeeID', e.target.value)}
          className="form-control"
        />
      ),
      newUsername: (
        <input
          type="text"
          value={tempUsername}
          onChange={(e) => handleInputChange(data.ID, 'newUsername', e.target.value)}
          className="form-control"
        />
      ),
      newPassword: (
        <input
          type="text"
          value={tempNewPassword}
          onChange={(e) => handleInputChange(data.ID, 'newPassword', e.target.value)}
          className="form-control"
        />
      ),
    }
  })

  const handleDealerChange = (e) => {
    const fname = e.target.name;
    const fvalue = e.target.value;
    setSearchDealer(prevState => ({
      ...prevState,
      [fname]: fvalue,
    }));
  }

  const handleSearchData = (e) => {
    e.preventDefault();
    setDataSearch(true);
    dispatch(dealerList(searchDealer.companyID, searchDealer.channelId, searchDealer.status));
    setAllowExport(true);
  }

  const handleClear = () => {
    if (filterText) {
      setFilterText("");
    }
  }

  if (props.updateError === 'Invalid token') {
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    window.location.href = '/';
  }

  const TmoBulkPassword = () => {
    dispatch(pageNumber(1))
  }

  const backTmoBulkPassword = () => {
    dispatch(pageNumber(0))
  }

  const listData = props.dealerData && props.dealerData.map((data, key) => {
    return {
      SNo: key + 1,
      DealerID: data.ID,
      DealerName: data.DealerName,
      ChannelName: data.ChannelName,
      NewUsername: data.NewUsername,
      NewPassword: data.NewPassword,
      EmployeeID: data.EmployeeID,
    }
  })

  const exportToCSV = async () => {
    if (listData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(listData);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      await FileSaver.saveAs(data, 'Add Dealer Credentials' + fileExtension);
    }
  }


  return (
    <>
      {
        props.pageNumberChnage === 1 ? <BulkUploadTMobilePassword back={backTmoBulkPassword} /> :
          <div className="nk-block-head-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3 className="nk-block-title page-title">Add Dealer Credentials</h3>
            </div>
            <div className="card p-2" style={{ marginTop: "12px" }}>
              {(props.updatemessage || props.bulkUpdatemessage) && (
                <div className="alert alert-success alert-icon"> <em className="icon ni ni-check-circle"></em> <strong>{props.updatemessage || props.bulkUpdatemessage}</strong> </div>)}
              {props.updateError &&
                <div className="alert alert-danger alert-icon"><em className="icon ni ni-cross-circle"></em> <strong>{props.updateError}</strong></div>}
              <div className="card-inner p-0">
                <div className="nk-block">
                  <form method="post" onSubmit={handleSearchData}>
                    <div className="row g-3 align-items-end">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label className="form-label" htmlFor="dealerID">Channel</label>
                          <div className="form-control-wrap">
                            <select
                              name="channelId"
                              className="form-control"
                              id="channelId"
                              value={searchDealer.channelId}
                              onChange={(e) => handleDealerChange(e)}
                            >
                              <option value="0" name="all">All</option>
                              {props.channelData && props.channelData.map(channel => (
                                <option key={channel.ID} value={channel.ID}>{channel.ChannelName}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-3'>
                        <button type='submit' disabled={props.loading} className="btn btn-primary" style={{ 'marginTop': '1.9rem' }}>{props.loading === true && <span
                          className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
                          <span>Search</span> </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {
              dataSearch ?
                <div className='card p-2'>
                  <div className="card-inner p-0" >
                    <div className=' d-flex justify-content-between'>
                      <FilterComponent
                        onFilter={e => setFilterText(e.target.value)}
                        onClear={handleClear}
                        filterText={filterText}
                      />
                      {
                        dataSearch ?
                          <div className="col text-end">
                            <Link to="#" className="btn btn-success me-2" onClick={() => allowExport && exportToCSV()}><em className="icon ni ni-download"></em> Export</Link>
                          </div> : ""}
                      <Link to="#" className="btn btn-primary" onClick={() => TmoBulkPassword()}><em className="icon ni ni-plus-sm"></em> T-Mobile Password Bulk Upload</Link>

                    </div>
                    <DataTable
                      columns={columns}
                      data={filterData}
                      customStyles={customStyles}
                      progressPending={props.loading}
                      progressComponent={<Spinner />}
                      striped
                      responsive
                    />
                  </div>
                </div>
                : ''}
            {
              dataSearch ?
                <div className='col-sm-12 text-end'>
                  <button type='submit' className="btn btn-primary" disabled={props.updateloading} style={{ 'marginTop': '1.9rem' }} onClick={handleUpdate}>
                    {props.updateloading === true && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
                    <span>Update</span> </button>
                </div>
                : ''}

            {popUp && <div className="modal fade zoom show" tabIndex="-1" id="modalZoom" style={{ "display": "block" }} aria-modal="true" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header bg-danger text-white">
                    <h5 className="modal-title">CONFIRM</h5><div className="nk-demo-close toggle btn btn-icon btn-trigger revarse mr-n2 active" data-target="demoML" ><em className="icon ni ni-cross text-white" onClick={() => setpopUp(false)}></em></div>
                  </div>
                  <div className="modal-body">
                    <p>{popUpDeleteContent}</p>
                  </div>
                  <div className="modal-footer"><div className="btn btn btn-outline-danger" onClick={() => setpopUp(false)}>No</div> <div className="btn btn btn-outline-success" onClick={() => handleconfirm()}>Yes</div></div>
                </div>
              </div>
            </div>}
          </div >
      }
    </>

  );
}
const mapStateToProps = (state) => {
  const { channelData, dealerData, apiError, message, loading, modalMessage } = state.dealer;
  const { updatemessage, updateError, updateloading, bulkUpdatemessage, pageNumberChnage } = state.addDealerCredentials;
  return { channelData, dealerData, apiError, message, loading, modalMessage, updatemessage, updateError, updateloading, bulkUpdatemessage, pageNumberChnage };
};

export default withRouter(connect(mapStateToProps, { getAllChannelList, dealerList, updateDealerCredentials, resetAlert, pageNumber })(AddDealerCredentials));